'use strict';

const { h } = require('phy');
const { hydrate } = require('@grpn/hydration');

function SharedModal({ className, closeHandler, children }) {
  const keyUpHandlerClose = ev => {
    if (ev.keyCode === 13) {
      closeHandler();
    }
  };

  return h(`.shared-modal.${className}`, [
    h('.shared-modal-overlay', { onClick: closeHandler }),
    h(
      '.shared-modal-wrapper',
      h('.shared-modal-frame', [
        h('.shared-modal-close.icon-x', {
          tabindex: 0,
          onClick: closeHandler,
          onKeyUp: keyUpHandlerClose,
        }),
        children,
      ])
    ),
  ]);
}

module.exports = hydrate('SharedModal', SharedModal);
